module.exports = function(key, edits) {
	const imageRequest = JSON.stringify({
		bucket: "babushka",
		key: key,
		edits: edits
	});
	return `${process.env.REACT_APP_IMAGE_CDN}/${btoa(imageRequest)}`;
};